import {Collapse, IconButton, TableCell, TableRow, Typography} from "@mui/material";
import React, {FC, useState} from "react";
import {UserRoutes} from "../../../models/ClimbingEventRoutesResults";
import {ResultCellComponent} from "./ResultCellComponent";
import {UserPointsAndPosition} from "./ResultListComponent";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Box} from "@mui/system";
import {StatusLabelAndColour, UserRouteStatus} from "../../../models/UserClimbingEvent";


type Props = {
    result: UserPointsAndPosition,
    routes: UserRoutes | undefined,
    separateZonePoints: boolean,
    isCurrentUser: boolean,
    statuses: StatusLabelAndColour[]
}

export const ResultRowComponent: FC<Props> = ({result, routes, separateZonePoints, isCurrentUser, statuses}) => {

    const [open, setOpen] = useState<boolean>(false)

    function getForRoutesAndStatus(s: StatusLabelAndColour, routes: UserRoutes | undefined): string {
        switch (s.status) {
            case UserRouteStatus.NOTHING:
                return ""
            case UserRouteStatus.FLASH:
                return routes?.flash || ""
            case UserRouteStatus.DONE:
                return routes?.top || ""
            case UserRouteStatus.LATER:
                return ""
            case UserRouteStatus.ZONE:
                return routes?.zones || ""
            case UserRouteStatus.ZONE2:
                return routes?.zones_2 || ""
        }
    }

    return (<><TableRow key={`results_${result.name}_${result.position}`}>

        <ResultCellComponent isCurrentUser={isCurrentUser} value={result.position.toString()}/>
        <ResultCellComponent isCurrentUser={isCurrentUser} value={result.name || ""}/>
        <ResultCellComponent isCurrentUser={isCurrentUser} value={result.points.toString()}/>
        {separateZonePoints &&
            <ResultCellComponent isCurrentUser={isCurrentUser} value={result.zones.toString() || "0"}/>
        }
        {statuses.length > 0 && routes &&
            <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
            >
                {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>
        }
    </TableRow>
        <TableRow>
            <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{margin: 1}}>
                        {statuses.map(s =>
                            <Box display={"flex"} gap={1}>
                                <> {React.createElement(s.icon, {style: {color: s.color}})}</>
                                <Typography fontWeight={700} minWidth={70}>
                                    {s.label}
                                </Typography>
                                <Typography>{getForRoutesAndStatus(s, routes)}</Typography>
                            </Box>
                        )}
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    </>)

}

